
import Vue from 'vue'
import Moment from 'moment'
import UserQR from '@/components/dashboard/UserQR.vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";
import CurrentDailyMenu from '@/components/dashboard/CurrentDailyMenu.vue'
import {IS_MOBILE, USER_LOGGED_IN} from '@/store/getter-types'
import {CurrentUser} from '@/model/CurrentUser'
import {
  FETCH_DASHBOARD,
  FETCH_TENANT_NAME,
  FETCH_TIME_BLOCK_COLLECTION, SET_SELECTED_MENU_ITEM,
  USER_DAILY_MENU
} from '@/store/action-types'
import {DashboardMessage} from '@/types'
import Message from '@/components/dashboard/Message.vue'
import LatestInvoice from '@/components/dashboard/LatestInvoice.vue'
import {formatFloatPrice} from '@/services/formatter'
import BusinessTimeBlockCollection from "@/model/TimeBlockCollection";
import UserQrCode from "@/components/dashboard/UserQrCode.vue";
import {usePiniaStore} from "@/store/piniaStore";
import {TranslateResult} from "vue-i18n";
import RatingDialog from "@/components/dashboard/RatingDialog.vue";
import {RatingModel} from "@/model/RatingModel";
import moment from "moment";

@Component({
  components: {
    RatingDialog,
    UserQR,
    CurrentDailyMenu,
    Message,
    LatestInvoice,
    UserQrCode
  }
})
export default class DashboardPage extends Vue {
  private messages: DashboardMessage[] = []
  private currentCreditBalance: number | null = null
  private formattedCurrentCreditBalance: string = ''
  private timeBlockCollection: BusinessTimeBlockCollection[] | null = null
  private settingsData: any[] = []
  private showQrCode: boolean = false
  private showCustomerQrCode: boolean = false
  private showSnackBar: boolean = false
  private snackBarText: TranslateResult | string = ''
  private snackBarColor: string = ''
  private piniaStore: any = usePiniaStore()
  private showDetailLastOrderClick: boolean = false
  private lastReservationDetailData: any[] = []
  private lastReservationNumber: number[] | null = []
  private showRatingLastOrder: boolean = false
  private selectedOfferRating: RatingModel | null = null
  private ratingDeliveryTimeData: number | null= null


  @Getter(USER_LOGGED_IN) currentUser!: CurrentUser
  @Action(USER_DAILY_MENU) fetchDailyMenu!: ({ (payload: any): Promise<void> })
  @Action(FETCH_DASHBOARD) fetchDashboard!: ({ (): Promise<any> })
  @Action(FETCH_TIME_BLOCK_COLLECTION) fetchTimeBlockCollection!: ({ (): Promise<BusinessTimeBlockCollection[]> })


  get getFormattedDate():string {
    let date: string = ''
      this.getReservationData.forEach((i:any) => {
       date = moment(i.date).locale('sk').format('D.M.YYYY dddd')
    })
    return date
  }

  get getReservationData():any {
    let data:any[] = []
    this.lastReservationDetailData!.forEach((item:any) => {
      item.forEach((i:any) => {
        data.push(i)
      })

    })
    return data
  }

  get isMobile(): boolean {
    return this.$store.getters[IS_MOBILE]
  }

  get getColor(): any {
    if (this.currentCreditBalance && this.currentCreditBalance < 0) {
      return 'red--text'
    } else if (this.currentCreditBalance && this.currentCreditBalance > 0) {
      return 'green--text'
    } else {
      return 'black--text'
    }
  }

  get shouldShowInvoiceWidget(): boolean {
    const isEmployee = this.currentUser.boarderList.filter((b: any) => {
      return !!b.boarderGroupCollection.find((g: any) => g.name === 'zamestnanci')
    }).length === 1

    return !isEmployee;
  }

  closeRatingDialog(): void{
    this.showDetailLastOrderClick = false
  }

  refreshData(): void{
    this.showDetailLastOrderClick = false
    this.fetchData()
  }

  onDetailLastOrderClick(): void{
    this.showDetailLastOrderClick = true
  }

  onQrCodeClick(): void {
    this.showQrCode = true
  }

  closeQrDialog(): void {
    this.showQrCode = false
  }

  onCreditDetailsClick() {
    this.$router.push({name: 'Credit'})
  }

  async fetchData(): Promise<void> {
    this.lastReservationNumber = []
    this.fetchDailyMenu({
      from: Moment().format('Y-MM-DD'),
      to: Moment().add(1, 'days').format('Y-MM-DD'),
      user_id: this.currentUser.getBoarder?.id
    })

    const dashboard = await this.fetchDashboard()
    dashboard.offerReservationsToRate.forEach((item:any) => {
      this.selectedOfferRating = item.offerReservationRating
      this.lastReservationNumber!.push(item.offerReservation.id)
    })
    if(this.lastReservationNumber !== null) {
      this.fetchLatestOrderDetail()
    }

    this.currentCreditBalance = dashboard.currentCreditBalance
    this.formattedCurrentCreditBalance = formatFloatPrice(dashboard.currentCreditBalance)
    this.fetchTimeBlockData()


    this.messages = dashboard.messages
  }

  async fetchSettingsData(): Promise<void> {
    try {
      this.settingsData = await this.$store.dispatch(FETCH_TENANT_NAME)
    } catch (e) {
    } finally {
    }
  }

  async fetchTimeBlockData (): Promise<void> {
    try {
      this.timeBlockCollection = await this.fetchTimeBlockCollection()
    }catch (e) {
    }
  }

  async fetchCustomer(): Promise<void> {
    let payload: any = this.currentUser.boarderList[0].customer.id
    try {
      const response = await this.piniaStore.fetchCustomerQrConfiguration(payload)
      this.showCustomerQrCode = response.configuration.show_boarder_card || false
      this.showRatingLastOrder = response.configuration.allow_rating_last_order || false
      this.ratingDeliveryTimeData = response.configuration.last_order_rating_delivery_time_delta
    } catch (e) {
      this.showSnackBar = true
      this.snackBarText = this.$t('errors.fetchDataError').toString()
      this.snackBarColor = 'error'
    } finally {
    }
  }

  async fetchLatestOrderDetail(): Promise<void> {
    this.lastReservationDetailData = []
    try {
      const promises: Promise<any>[] = []
      this.lastReservationNumber!.forEach((number: number) => {
        let payload: any = number
        promises.push(this.piniaStore.fetchLastOrder(payload))
      })
      const responses = await Promise.all(promises)
        this.lastReservationDetailData.push(responses)
    } catch (e) {
    }
  }

  async created() {
    await this.fetchCustomer()
  }

  mounted(): void {
    this.fetchData()
    this.fetchSettingsData()

  }
}
